import classNames from 'classnames'
import { forwardRef, HTMLAttributes } from 'react'

import FooterBottom from './footer-bottom'
import FooterCopyright from './footer-copyright'
import FooterHead from './footer-head'
import FooterMenu from './footer-menu'
import styles from './footer-root.module.scss'
import FooterSocial from './footer-social'

export type FooterRootVariant = 'full' | 'minimal'

export type FooterRootElement = HTMLDivElement
export type FooterRootProps = HTMLAttributes<FooterRootElement> & {
  /**
   * Controls the default footer content rendered when no `children` are provided.
   * - `full`: SEO menu columns + copyright + social (default — keeps SEO for anonymous users).
   * - `minimal`: only copyright + social. Used for logged-in users on legal-professionals
   *   pages, where the SEO menu adds no value and acts as a distraction.
   */
  variant?: FooterRootVariant
}

const FooterRoot = forwardRef<FooterRootElement, FooterRootProps>(function FooterRoot(
  props,
  forwardedRef
) {
  const { children, className, variant = 'full', ...rest } = props

  const classes = classNames(styles.root, className)
  return (
    <footer {...rest} className={classes} ref={forwardedRef}>
      {children ?? (
        <>
          {variant === 'full' && (
            <FooterHead>
              <FooterMenu />
            </FooterHead>
          )}
          <FooterBottom>
            <FooterCopyright />
            <FooterSocial />
          </FooterBottom>
        </>
      )}
    </footer>
  )
})

export default FooterRoot
